import { __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkOverlayButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { isYoutubeSource, youTubeThumbnailImage } from 'uitk-react-video';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-media-gallery.css';
var getClassNameList = classNames.bind(styles);
var base64TransparentSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
var MediaGalleryThumbnail = function (_a) {
  var alt = _a.alt,
    src = _a.src,
    onImageSelected = _a.onImageSelected,
    index = _a.index,
    focusIndex = _a.focusIndex,
    caption = _a.caption,
    l10n = _a.l10n,
    imagesRatio = _a.imagesRatio,
    containerRef = _a.containerRef;
  var imgRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  React.useEffect(function () {
    var observer = new IntersectionObserver(function (_a) {
      var entry = _a[0];
      if (entry.isIntersecting && (imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) && src) {
        imgRef.current.setAttribute('src', src);
        imgRef.current.removeAttribute('data-lazy');
        observer.disconnect();
      }
    }, {
      root: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current,
      rootMargin: '0px 0px 300px 0px'
    });
    (imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) && observer.observe(imgRef.current);
    if (focusIndex === index && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
      buttonRef.current.focus();
    }
    return function () {
      observer.disconnect();
    };
  }, [containerRef, focusIndex, index, src]);
  var buttonLabel = caption ? l10n.formatText('mediagallery.thumbnailWithCaption', caption) : l10n.formatText('mediagallery.thumbnailWithoutCaption', index + 1);
  var imageProps = {
    alt: alt,
    src: isYoutubeSource(src) ? youTubeThumbnailImage(src) : base64TransparentSrc,
    imgRef: imgRef,
    additionalProps: {
      'data-lazy': true
    }
  };
  var button = focusIndex === index ? buttonRef : undefined;
  var uitkMediaGalleryThumbnailBaseClass = 'uitk-media-gallery-thumbnail';
  return React.createElement("li", {
    className: getClassNameList(uitkMediaGalleryThumbnailBaseClass)
  }, React.createElement(UitkFigure, {
    ratio: imagesRatio || UitkFigure.AspectRatio.R1_1
  }, React.createElement(UitkImage, __assign({
    placeholderImage: true
  }, imageProps))), isYoutubeSource(src) ? React.createElement(UitkLayoutPosition, {
    position: {
      top: 'center',
      left: 'center'
    },
    type: "absolute"
  }, React.createElement(UitkOverlayButton, {
    "aria-label": buttonLabel,
    onClick: onImageSelected
  }, React.createElement(UitkIcon, {
    name: "play_arrow"
  }))) : React.createElement("button", {
    type: "button",
    ref: button,
    className: getClassNameList("".concat(uitkMediaGalleryThumbnailBaseClass, "-link")),
    onClick: onImageSelected
  }, React.createElement("span", {
    className: "is-visually-hidden"
  }, buttonLabel)));
};
var UitkMediaGalleryThumbnail = function (props) {
  var l10n = useLocalization();
  return React.createElement(MediaGalleryThumbnail, __assign({
    l10n: l10n
  }, props));
};
export { MediaGalleryThumbnail, UitkMediaGalleryThumbnail };